module.exports = __webpack_public_path__ + "img/icon_meeting.ef16775c.png";